import { useEffect, useState } from 'react';
import type { CuttlefishConnection } from '../types';

export const useCuttlefishDeviceStreams = (connection: CuttlefishConnection | null) => {
  const [streams, setStreams] = useState<Map<string, MediaStream>>(new Map());
  const [audioStream, setAudioStream] = useState<MediaStream | null>(null);

  useEffect(() => {
    if (!connection) return;

    const handleStreamChange = (stream: MediaStream) => {
      setStreams((prev) => {
        const newMap = new Map(prev);
        newMap.set(stream.id, stream);
        return newMap;
      });
    };

    connection.onStreamChange(handleStreamChange);

    if (connection.description?.audio_streams) {
      const audioDescs = connection.description.audio_streams;
      if (audioDescs.length > 0) {
        const firstStream = audioDescs[0];
        if (firstStream) {
          const streamId = firstStream.stream_id;
          connection
            .onStream(streamId)
            .then((stream) => {
              setAudioStream(stream);
            })
            .catch((e) => console.error('Unable to get audio stream: ', e));
        }
      }
    }
  }, [connection]);

  return {
    streams,
    audioStream,
    getStream: (streamId: string) => streams.get(streamId) || null,
  };
};
